import axiosInstance from '../../api/axiosInstance';
import { RolesResponse} from '../../types/permissions/role';
import { RoleResponse } from '../../types/permissions/roleResponse';

export const roleService = {
  // Obtener todos los roles
  getRoles: async (): Promise<RolesResponse> => {
    const response = await axiosInstance.get<RolesResponse>('/users/roles');
    return response.data;
  },

  // Crear nuevo rol
  createRole: async (roleData: { name: string; description: string }): Promise<RoleResponse> => {
    const response = await axiosInstance.post<RoleResponse>('/users/roles', roleData);
    return response.data;
  },

  // Eliminar rol
  deleteRole: async (roleId: number): Promise<RoleResponse> => {
    const response = await axiosInstance.delete<RoleResponse>(`/users/roles/${roleId}`);
    return response.data;
  }
};
